import { render, staticRenderFns } from "./nutritionist-tracking.vue?vue&type=template&id=0d548119&"
import script from "./nutritionist-tracking.vue?vue&type=script&lang=js&"
export * from "./nutritionist-tracking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CHeading: require('@chakra-ui/vue').CHeading, CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox, CGrid: require('@chakra-ui/vue').CGrid, CText: require('@chakra-ui/vue').CText, CSelect: require('@chakra-ui/vue').CSelect})
